export default "__VITE_ASSET__CgMsD8aF__"